import React, { useEffect, useState } from "react";
import { Row, Modal, Menu, Dropdown, Button, Empty, Spin, Alert } from "antd";
import { Link } from "react-router-dom";
import {
  DownOutlined,
  PlusOutlined,
  CloseCircleOutlined
} from "@ant-design/icons";
import moment from "moment";
import { withUser } from "pages/context/user";
import * as qs from "query-string";
import { loginAfterUrl } from "pages/config";
import {
  getCustomerList,
  getServiceList,
  setCompanyId,
  getCompanyId,
  getTestServiceList,
  getCustomerTestServiceList,
  assignStyleCompanyId
} from "apis/user";
import { registeredUserInfo, getServices } from "apis/admin";
import AddCompany from "pages/manager/company/companyList/add";
import { withCompanySetting } from "pages/context/companySetting";
import cookies from "js-cookie";
import BindingAleft from "pages/index/components/userBox/bindingAlert";
import Alerts from "pages/index/components/userBox/qrAlert";
import { showMessage } from "utils";
import { rightHost, fangPhoneArr, fangZiArr } from "components/common";
import { Steps } from "intro.js-react";
import RegFrirstAlerts from "./regFristAlert";
import "intro.js/introjs.css";
import "../../userCommon.css";
import CatiModal from "./catiModal";

const { axios } = window;
export default withUser(
  withCompanySetting(function WorkBench({
    companySetting,
    user,
    history,
    location
  }) {
    const phoneNumber = user.self.phone;
    const iphoneNumberArr = [
      "19520476086",
      "13004052037",
      "15110167771",
      "15210505833",
      "13552053960",
      "13051261540",
      "18911231290",
      "18342201756",
      "17397398708",
      "18301469837",
      "13161381260",
      "13920659963",
      "18610314682",
      "18526700090",
      "15122780962",
      "17561421019",
      "18612519511",
      "15811065753",
      "13366686551",
      "15311479963",
      "18233070923",
      "18601072842",
      "13096901397",
      "13611202732",
      "15611787180",
      "13269635262",
      "17856516312",
      "13842990613",
      "18822212253",
      "18292007259",
      "15652964952"
    ];
    const token = cookies.get("shorcuts");
    // const [roles, token] = getToken();
    const [bindingBol, setBndingBol] = useState(false);
    //  判断是否显示绑定type  1 不显示  2 显示
    const [bindingBolType] = useState(2);
    const [alertBol, setAlertBol] = useState(false);
    const { companyid, domainId, forwardUrl } = qs.parse(
      window.location.search
    );
    console.log("forwardUrl", forwardUrl);
    const [owner, setOwner] = useState(false);
    const [finnalCompanyid] = useState(companyid);
    const [visible, setVisible] = useState(false);
    const [loding, setLoding] = useState(true);
    const [bol, setBol] = useState(false);
    // 方舟开关 ，根据fangPhoneArr  数组显示 （只显示部分标签，其他隐藏）
    const [fangBol, setFangBol] = useState(false);
    const [service, setService] = useState([]);
    const [companyList, setCompanyList] = useState([]);
    const [activeInfo, setActiveInfo] = useState([]);
    // const [alertVisible, setAlertVisible] = useState(false);

    const params = qs.parse(window.location.search);
    // console.log(params);
    const time = new Date();
    const t = moment(time).valueOf();
    // 新手指导
    const [steps, setSteps] = useState([]);
    const [stepsBol, setStepsBol] = useState(false);
    // 新手指导左侧关闭
    const [xinYinBoxBol, setxinYinBoxBol] = useState(
      !cookies.get("dingzhiBol")
    );
    // CATI云电话
    const [catiTelVis, setCatiTelVis] = useState(false);

    // 我的服务模块(一般企业和个人)
    const [workServer, setWorkServer] = useState([
      {
        id: 2,
        name: "明察暗访",
        icon: "/img/mc.png",
        describe: "应用场景：实地检查、暗访、台账普查等",
        use: "进入",
        dev: `https://pro.jianchaba.com/dashboard?token=${token}&t=${t}`,
        pro: `https://pro.jianchaba.com/dashboard?token=${token}&t=${t}`,
        opennew: false
      },
      {
        id: 1,
        name: "网络调查",
        icon: "/img/wl.png",
        describe: "应用场景：问卷调查、满意度调查、报名表登记、投票等",
        use: "进入",
        dev: `http://testcloud.treeyee.com/?token=${token}${
          companyid ? `&companyid=${companyid}` : ""
        }&t=${t}&url=http://testcloudweb.treeyee.com#/`,
        pro: `https://pro.wenjuanba.com/?token=${token}${
          companyid ? `&companyid=${companyid}` : ""
        }&t=${t}&url=https://proweb.wenjuanba.com#/`,
        opennew: false
      },
      {
        id: 1,
        name: "面对面访问",
        icon: "/img/mdm.png",
        describe: "应用场景：线下面访，街头拦访，入户调查等",
        use: "进入",
        dev: `http://test.qyconsult.treeyee.com:5000?token=${token}&role=manager&t=${t}`,
        pro: `https://pxb.treeyee.com?token=${token}&role=manager&t=${t}`,
        opennew: false
      },
      {
        id: 1,
        name: "CATI 云电话调查",
        icon: "/img/tel.png",
        describe: "应用场景：问卷调查、客户满意度调查、客户回访",
        use: "进入",
        dev: ``,
        pro: ``,
        opennew: false
      },
      // {
      //   id: 4,
      //   name: "调研培训",
      //   icon: "/img/wj.png",
      //   describe: "应用场景：调研人员培训、企业内部培训、专业技能培训等",
      //   use: "进入",
      //   dev: `http://test.qyconsult.treeyee.com:5000?token=${token}&role=manager&t=${t}`,
      //   pro: `https://pxb.treeyee.com?token=${token}&role=manager&t=${t}`,
      //   opennew: false
      // },
      {
        id: 3,
        name: "任务广场",
        icon: "/img/renwu.png",
        describe: "应用场景：调研任务外包、承接、结算等",
        // tips: "敬请期待",
        use: "进入",
        dev: `https://pro.jianchaba.com/dashboard?token=${token}&t=${t}`,
        pro: `https://pro.jianchaba.com/dashboard?token=${token}&t=${t}`,
        // class: "tips tips2",
        btnClass: "enter",
        show: !cookies.get("dingzhiBol"),
        opennew: true
      },
      // {
      //   id: 13,
      //   name: "材料申报系统",
      //   icon: "/img/sbxt.png",
      //   describe: "应用场景：材料收集、审核、考核评分等",
      //   use: "进入",
      //   dev: `http://test.qyconsult.treeyee.com:5000?token=${token}&role=manager&t=${t}`,
      //   pro: `https://pxb.treeyee.com?token=${token}&role=manager&t=${t}`
      // },
      // {
      //   id: 123,
      //   name: "结算中心",
      //   icon: "/img/jiesuan.png",
      //   describe: "项目执行费用统计、在线结算、导出",
      //   use: "进入",
      //   dev: `/user/workbench/balance?companyid=${companyid}`
      // },
      {
        id: 123,
        name: "访问员库",
        icon: "/img/fangwy.png",
        describe: "维护访问员信息等",
        use: "进入",
        dev: `/user/workbench/visitor?companyid=${companyid}`
      },
      {
        id: 123,
        name: "代理商库",
        icon: "/img/daili.png",
        describe: "维护代理商信息等",
        use: "进入",
        dev: `/user/workbench/agent?companyid=${companyid}`
      }
    ]);
    // 我的服务模块(定制企业)
    const [workDingZhiServer, setWorkDingZhiServer] = useState([]);
    // 获取企业定制相关信息
    const getDingzhiInfo = () => {
      getServices({ companyId: companyid }).then(res => {
        console.log(res);
        // 明察暗访
        const mingcha = res.filter(item => item.serviceType === 2);
        // 网络调查&面对面访问&代理结算
        const wangluo = res.filter(item => item.serviceType === 1);
        // 调研培训
        const peixun = res.filter(item => item.serviceType === 4);
        // 任务广场
        const renwuguangchang = res.filter(item => item.serviceType === 3);
        // 自然语言处理
        const ziranyuyan = res.filter(item => item.serviceType === 17);
        // 企业管理工具
        const qiyeguanli = res.filter(item => item.serviceType === 16);
        setWorkDingZhiServer([
          {
            id: 2,
            name: mingcha[0].names[0],
            icon: "/img/mc.png",
            describe: "应用场景：实地检查、暗访、台账普查等",
            use: "进入",
            onhref: `${mingcha[0].serviceDomain}?token=${cookies.get(
              "shorcuts"
            )}&companyid=${companyid}`,
            shows: mingcha[0].locks[0],
            newopen: mingcha[0].openNew
          },
          {
            id: 1,
            name: wangluo[0].names[0],
            icon: "/img/wl.png",
            describe: "应用场景：问卷调查、满意度调查、报名表登记、投票等",
            use: "进入",
            onhref: `${wangluo[0].serviceDomain}?token=${cookies.get(
              "shorcuts"
            )}&companyid=${companyid}`,
            shows: wangluo[0].locks[0],
            newopen: wangluo[0].openNew
          },
          {
            id: 1,
            name: wangluo[0].names[1],
            icon: "/img/mdm.png",
            describe: "应用场景：线下面访，街头拦访，入户调查等",
            use: "进入",
            onhref: `${wangluo[0].serviceDomain}?token=${cookies.get(
              "shorcuts"
            )}&companyid=${companyid}`,
            shows: wangluo[0].locks[1],
            newopen: wangluo[0].openNew
          },
          {
            id: 1,
            name: "CATI 云电话调查",
            icon: "/img/tel.png",
            describe: "应用场景：问卷调查、客户满意度调查、客户回访",
            use: "进入",
            onhref: `${wangluo[0].serviceDomain}?token=${cookies.get(
              "shorcuts"
            )}&companyid=${companyid}`,
            shows: true,
            newopen: true
          },
          {
            id: 4,
            name: peixun[0].names[0],
            icon: "/img/wj.png",
            describe: "应用场景：调研人员培训、企业内部培训、专业技能培训等",
            use: "进入",
            onhref: `${peixun[0].serviceDomain}?token=${cookies.get(
              "shorcuts"
            )}&companyid=${companyid}&role=learner`,
            shows: peixun[0].locks[0],
            newopen: peixun[0].openNew
          },
          {
            id: 3,
            name: renwuguangchang[0].names[0],
            icon: "/img/renwu.png",
            describe: "应用场景：调研任务外包、承接、结算等",
            use: "进入",
            btnClass: "enter",
            onhref: `${renwuguangchang[0].serviceDomain}?token=${cookies.get(
              "shorcuts"
            )}&companyid=${companyid}`,
            shows: renwuguangchang[0].locks[0],
            newopen: renwuguangchang[0].openNew
          },
          {
            id: 17,
            name: ziranyuyan[0].names[0],
            icon: "/img/renwu.png",
            describe: "",
            use: "进入",
            btnClass: "enter",
            onhref: `${ziranyuyan[0].serviceDomain}?token=${cookies.get(
              "shorcuts"
            )}&companyid=${companyid}`,
            // shows: ziranyuyan[0].locks[0]
            shows: false,
            newopen: false
          },
          {
            id: 16,
            name: qiyeguanli[0].names[0],
            icon: "/img/renwu.png",
            describe: "",
            use: "进入",
            btnClass: "enter",
            onhref: `${qiyeguanli[0].serviceDomain}?token=${cookies.get(
              "shorcuts"
            )}&companyid=${companyid}`,
            // shows: qiyeguanli[0].locks[0]
            shows: false,
            newopen: false
          },
          // {
          //   id: 1,
          //   name: "结算中心",
          //   icon: "/img/jiesuan.png",
          //   describe: "项目执行费用统计、在线结算、导出",
          //   use: "进入",
          //   onhref: `/user/workbench/balance?companyid=${companyid}`,
          //   shows: wangluo[0].locks[0],
          //   newopen: wangluo[0].openNew
          // },
          {
            id: 123,
            name: "访问员库",
            icon: "/img/fangwy.png",
            describe: "维护访问员信息等",
            use: "进入",
            onhref: `/user/workbench/visitor?companyid=${companyid}`,
            shows: true
          },
          {
            id: 123,
            name: "代理商库",
            icon: "/img/daili.png",
            describe: "维护代理商信息等",
            use: "进入",
            onhref: `/user/workbench/agent?companyid=${companyid}`,
            shows: true
          }
        ]);
      });
    };
    // 定制企业跳转
    const dingzhiEnters = item => {
      // if (item.id === 2 && companyid * 1 === 0) {
      //   setAlertVisible(true);
      //   return false;
      // }
      if (!item.newopen) {
        window.location.href = item.onhref;
      } else {
        window.open(item.onhref, "_blank");
      }
    };

    // 设置风格企业ID
    const setStyleID = id => {
      assignStyleCompanyId(id).then(res => {
        if (!res) {
          setStyleID(id);
        }
      });
    };
    const [regFirstBol, setRegFirstBol] = useState(
      cookies.get("regFirstBol") && !cookies.get("dingzhiBol")
    );
    // console.log(cookies.get("regFirstBol"));
    // const [regFirstBol, setRegFirstBol] = useState(true);
    // 新手指导
    const newUserPonit = ower => {
      const timer = setInterval(() => {
        if (
          document.getElementsByClassName("ant-dropdown-link")[0] ||
          document.getElementsByClassName("oneShenfen")[0]
        ) {
          if (ower) {
            setSteps([
              {
                element: ".ant-dropdown-link",
                intro: "您可在此处创建企业或切换企业使用调研工厂"
              },
              {
                element: ".jrButton",
                intro:
                  "您可以通过此处进入企业管理后台，管理企业员工、企业钱包充值等功能"
              },
              {
                element: ".servicebox1",
                intro:
                  "调研工厂提供的产品服务包括明察暗访、网络调查、面对面访问、调研培训、材料申报系统，点击进入即可使用"
              },
              {
                element: ".servicebox2",
                intro:
                  "调研工厂提供的试用功能包括：任务广场、企业管理工具、数据分析工具，点击进入即可使用"
              },
              {
                element: ".user-box",
                intro:
                  "点击头像可查看用户个人中心，您可在此新建企业/切换企业、修改个人信息、绑定微信、修改密码、退出等操作。",
                position: "left",
                highlightClass: "userToop"
              },
              {
                element: ".gerenRz",
                intro: "您可以通过此处进行个人用户认证",
                position: "left",
                highlightClass: "gerenRzToop"
              },
              {
                element: ".companyInfo",
                intro: "您可以通过此处进行企业身份认证，认证成功后图标会点亮",
                position: "left",
                highlightClass: "qiyeRzToop"
              },
              {
                element: ".helpBox",
                intro: "您可以通过此处进入帮助中心查看产品服务使用说明",
                highlightClass: "helpToop",
                position: "left"
              }
            ]);
          } else {
            setSteps([
              {
                element: document.getElementsByClassName("ant-dropdown-link")[0]
                  ? ".ant-dropdown-link"
                  : ".oneShenfen",
                intro: "您可在此处创建企业或切换企业使用调研工厂",
                hintAnimation: false
              },
              {
                element: ".servicebox1",
                intro:
                  "调研工厂提供的产品服务包括明察暗访、网络调查、面对面访问、调研培训、材料申报系统，点击进入即可使用"
              },
              {
                element: ".servicebox2",
                intro:
                  "调研工厂提供的试用功能包括：任务广场、企业管理工具、数据分析工具，点击进入即可使用"
              },
              {
                element: ".user-box",
                intro:
                  "点击头像可查看用户个人中心，您可在此新建企业/切换企业、修改个人信息、绑定微信、修改密码、退出等操作。",
                position: "left",
                highlightClass: "userToop"
              },
              {
                element: ".companyInfo",
                intro: "您可以通过此处进行个人用户认证",
                position: "left",
                highlightClass: "gerenRzToop"
              },
              {
                element: ".helpBox",
                intro: "您可以通过此处进入帮助中心查看产品服务使用说明",
                highlightClass: "helpToop",
                position: "left"
              }
            ]);
          }
          setStepsBol(true);
          clearInterval(timer);
        }
      }, 200);
    };
    const getList = () => {
      getCustomerList().then(data => {
        data.map(x => {
          if (finnalCompanyid * 1 === x.companyId) {
            setActiveInfo(x);
            // setCompanyId({ companyId: x.companyId });
            setOwner(x.owner);
          }
          return "";
        });
        setCompanyList(data);
        getCompanyId({ token }).then(datas => {
          // -1 就讓選擇企業，必須是有企業的情況 companyid  -1
          if (
            datas.id < 0 &&
            user.self.myCompanys.length !== 0 &&
            companyid === "-1"
          ) {
            history.push({
              search: qs.stringify({
                ...params,
                is: true
              }),
              pathname: "/index"
            });
          }
          // -1 并且地址欄是-1  companyid  -1 默認補 0
          if (
            datas.id < 0 &&
            user.self.myCompanys.length === 0 &&
            companyid === "-1"
          ) {
            history.push(`/user/workbench/home?companyid=0`);
          }
          if (datas.id > 0 && data.length !== 0) {
            if (companyid * 1 !== datas.id || !companyid) {
              history.push(`/user/workbench/home?companyid=${datas.id}`);
            }
            companySetting.dispatch({ type: "init" });
          } else if (
            (datas.id === 0 && data.length !== 0 && companyid * 1 !== 0) ||
            !companyid
          ) {
            history.push(`/user/workbench/home?companyid=0`);
            companySetting.dispatch({ type: "init" });
          } else if (!companyid) {
            if (data.length === 0) {
              return;
            }
            if (data.length === 1) {
              history.push(
                `/user/workbench/home?companyid=${data[0].companyId}`
              );
              companySetting.dispatch({ type: "init" });
              return;
            }
            history.push(`/index`);
          }
          if (
            companyid === "0" &&
            !cookies.get("jiluCompanyid") &&
            datas.id === -1
          ) {
            setCompanyId({ companyId: 0 });
            sessionStorage.removeItem("dingzhiBol");
            cookies.remove("dingzhiBol");
          }
          // 强制补充公司信息
          if (datas.modify && datas.id > 0) {
            Modal.info({
              title: "提示",
              content: `${
                datas.admin > 0
                  ? "根据相关规定，您所在的企业信息不完整，请完善相关信息。"
                  : "根据相关规定，您所在的企业信息不完整，请联系管理员完善。"
              }`,
              onOk() {
                if (datas.admin > 0) {
                  window.location.href = `/company/setting/set?companyid=${datas.id}`;
                }
              }
            });
          }
        });
      });
    };
    const getServiceFn = () => {
      console.log("finnalCompanyid", cookies.get("jiluCompanyid"));
      let id = finnalCompanyid;
      if (
        id === "0" &&
        cookies.get("jiluCompanyid") &&
        cookies.get("jiluCompanyid") !== "undefined"
      ) {
        id = cookies.get("jiluCompanyid");
      }
      console.log("id", typeof cookies.get("jiluCompanyid"));
      getServiceList({
        companyId: id
      }).then(data => {
        setLoding(false);
        console.log(data);
        setService(data);
      });
    };
    // 判断是否在数组内
    const funs = (param, value) => {
      param.includes(value) ? setBol(true) : setBol(false);
    };
    useEffect(() => {
      getDingzhiInfo();
      getList();
      getServiceFn();
      funs(iphoneNumberArr, phoneNumber);
      // 方舟 设置
      if (fangPhoneArr.includes(phoneNumber) || fangZiArr.includes(companyid)) {
        setFangBol(true);
        setWorkServer([
          {
            id: "fang2",
            name: "明察暗访",
            icon: "/img/mc.png",
            describe: "应用场景：实地检查、暗访、台账普查等",
            use: "进入",
            dev: `http://jc.fangzhou.survey.work`
          },
          {
            id: "fang1",
            name: "网络调查",
            icon: "/img/wl.png",
            describe: "应用场景：问卷调查、满意度调查、报名表登记、投票等",
            use: "进入",
            dev: "https://fangzhou.survey.work"
          },
          {
            id: "fang3",
            name: "面对面访问",
            icon: "/img/mdm.png",
            describe: "应用场景：线下面访，街头拦访，入户调查等",
            use: "进入",
            dev: "https://fangzhou.survey.work"
          }
        ]);
      } else {
        setFangBol(false);
      }
      // if (companyid) {
      //   axios
      //     .get(`/companySetting/net?companyId=${companyid}`)
      //     .then(function({ status, data }) {
      //       if (status !== 200) {
      //       }

      //       // setTitlePage(data.domain.factoryTitle);
      //     });
      // }
    }, []);

    const menu = (
      <Menu className="spMenu">
        {companyList.map(x => {
          return (
            x.join && (
              <Menu.Item key={x.companyId}>
                <a
                  onClick={() => {
                    Modal.confirm({
                      title: "提示",
                      content: (
                        <div>
                          <p>是否切换到 {x.companyName}?</p>
                          <p>切换后，已打开的服务的企业也会随之切换</p>
                        </div>
                      ),
                      okText: "确定",
                      cancelText: "取消",
                      onOk() {
                        if (x.effect) {
                          setStyleID(x.companyId, cookies.get("shorcuts"));
                        } else {
                          setStyleID(0, cookies.get("shorcuts"));
                        }
                        setCompanyId({ companyId: x.companyId }).then(() => {
                          window.location.href = `/user/workbench/home?companyid=${
                            x.companyId
                          }${domainId ? `&domainId=${domainId}` : ""}`;
                        });
                        // user.dispatch({
                        //   type: "set-current-company",
                        //   payload: x
                        // });
                        // user.dispatch({ type: "init" });
                        // companySetting.dispatch({ type: "init" });

                        // history.push(
                        //   `/user/workbench/home?companyid=${x.companyId}${
                        //     domainId ? `&domainId=${domainId}` : ""
                        //   }`
                        // );
                      }
                    });
                  }}
                  title={x.companyName}
                >
                  {x.companyName}
                </a>
              </Menu.Item>
            )
          );
        })}
        <Menu.Item key="sp1">
          <a
            onClick={() => {
              setCompanyId({ companyId: 0 }).then(() => {
                window.location.href = `/user/workbench/home?companyid=0${
                  domainId ? `&domainId=${domainId}` : ""
                }`;
                sessionStorage.removeItem("dingzhiBol");
                cookies.remove("dingzhiBol");
                cookies.remove("jiluCompanyid");
              });
            }}
          >
            个人用户
          </a>
        </Menu.Item>
        <Menu.Item key="sp2">
          <a
            onClick={() => {
              setVisible(true);
            }}
          >
            <PlusOutlined /> 新建企业
          </a>
        </Menu.Item>
      </Menu>
    );
    // // 功能实验室模块
    const functionLab = [
      // {
      //   id: 3,
      //   name: "任务广场",
      //   icon: "/img/dd.png",
      //   describe: "应用场景：调研任务外包、承接、结算等",
      //   // tips: "敬请期待",
      //   use: "进入",
      //   dev: `https://pro.jianchaba.com/dashboard?token=${token}&t=${t}`,
      //   pro: `https://pro.jianchaba.com/dashboard?token=${token}&t=${t}`,
      //   // class: "tips tips2",
      //   btnClass: "enter",
      //   show: !cookies.get("dingzhiBol")
      // },
      // {
      //   id: bol ? 888 : 88,
      //   name: "材料申报系统（内测版）",
      //   icon: "/img/sb.png",
      //   describe: "应用场景：材料收集、审核、考核评分等",
      //   tips: bol ? "" : "敬请期待",
      //   use: bol ? "进入" : "敬请期待",
      //   dev: `http://test.qyconsult.treeyee.com:5000?token=${token}&role=manager&t=${t}`,
      //   pro: `https://pxb.treeyee.com?token=${token}&role=manager&t=${t}`,
      //   class: bol ? "" : "tips tips2",
      //   btnClass: "enter",
      //   show: !cookies.get("dingzhiBol")
      // },
      {
        id: 16,
        name: "企业管理工具",
        icon: "/img/fang.png",
        describe: "应用场景：企业项目管理、企业资质管理、企业专家库等",
        // tips: "敬请期待",
        use: "进入",
        dev: `http://test.qyconsult.treeyee.com:5000?token=${token}&role=manager&t=${t}`,
        pro: `https://pxb.treeyee.com?token=${token}&role=manager&t=${t}`,
        class: "",
        btnClass: "enter",
        show: true
      },
      // {
      //   id: 17,
      //   name: "数据分析工具",
      //   icon: "/img/message.png",
      //   describe: "应用场景：中文分词，关键词提取生成词云，批量生成报告",
      //   // tips: "敬请期待",
      //   use: "进入",
      //   dev: `http://test.qyconsult.treeyee.com:5000?token=${token}&role=manager&t=${t}`,
      //   pro: `https://pxb.treeyee.com?token=${token}&role=manager&t=${t}`,
      //   // class: "tips tips2",
      //   btnClass: "enter",
      //   show: true
      // },
      {
        id: 9991,
        name: "问卷系统（新版）",
        icon: "/img/wl.png",
        describe: "应用场景：问卷调查",
        // tips: "进入",
        use: "进入",
        dev: `http://testcloud.treeyee.com/entrance?token=${token}${
          companyid ? `&companyid=${companyid}` : ""
        }&t=${t}&url=http://testcloudweb.treeyee.com#/`,
        pro: `https://wj.survey.work/entrance?token=${token}${
          companyid ? `&companyid=${companyid}` : ""
        }&t=${t}&url=https://wj.survey.work/`,
        btnClass: "enter",
        show: false
      },
      // {
      //   id: 999,
      //   name: "网络调查（内测版）",
      //   icon: "/img/wl.png",
      //   describe: "应用场景：问卷调查、满意度调查、报名表登记、投票等",
      //   use: "进入",
      //   dev: `http://testcloud.treeyee.com/?token=${token}${
      //     companyid ? `&companyid=${companyid}` : ""
      //   }&t=${t}&url=http://testcloudweb.treeyee.com#/`,
      //   pro: `https://pro.wenjuanba.com/?token=${token}${
      //     companyid ? `&companyid=${companyid}` : ""
      //   }&t=${t}&url=https://proweb.wenjuanba.com#/`,
      //   btnClass: "enter",
      //   show: bol
      // },
      {
        id: 777,
        name: "网络调查（预发布）",
        icon: "/img/wl.png",
        describe: "应用场景：问卷调查、满意度调查、报名表登记、投票等",
        // tips: "进入",
        use: "进入",
        dev: `https://staging-wj.survey.work/entrance?token=${token}${
          companyid ? `&companyid=${companyid}` : ""
        }&t=${t}&url=http://testcloudweb.treeyee.com#/`,
        pro: `https://staging-wj.survey.work/entrance?token=${token}${
          companyid ? `&companyid=${companyid}` : ""
        }&t=${t}&url=https://staging-wj.survey.work/`,
        btnClass: "enter",
        show: bol
      }
    ];
    // 开通相关逻辑
    const openModal = (serviceType, urls) => {
      Modal.confirm({
        title: "开通提示",
        content: `您可免费使用“${urls.name}”服务，是否开通？`,
        okText: "免费开通",
        cancelText: "暂不开通",
        onOk() {
          if (companyid === "0") {
            getCustomerTestServiceList({
              serviceType
            }).then(() => {
              showMessage("success", "开通成功，赶快使用吧！");
              getServiceFn();
            });
          } else {
            getTestServiceList({
              companyId: companyid,
              serviceType
            }).then(() => {
              showMessage("success", "开通成功，赶快使用吧！");
              getServiceFn();
            });
          }
        }
      });
    };
    const enters = urls => {
      if (urls.id === 123) {
        window.location.href = urls.dev;
        return;
      }
      const a = document.createElement("a");
      // a.setAttribute("target", "_blank");
      a.setAttribute("id", "btnA");
      // a.innerHTML = "测试啊啊啊啊";
      if (!document.getElementById("btnA")) document.body.appendChild(a);

      let final = "";

      // 个人用户进入检查吧
      // if (urls.id === 2 && companyid * 1 === 0) {
      //   setAlertVisible(true);
      //   return;
      // }

      axios.get("/customer/userInfo").then(function(response) {
        if (response.status !== 200) {
          return;
        }
        let serviceDomain = "";
        //  0 无限制  ， 1 必须是企业  ， 2必须是个人
        let serviceQualifier = "";
        let serviceId = 0; // 当出现serviceId为0时，表示企业或用户未开通该服务，不可直接跳转，需要开通服务。
        let serviceType = 0;
        service.map(x => {
          if (urls.id === x.serviceType) {
            serviceDomain = x.serviceDomain;
            serviceQualifier = x.serviceQualifier;
            serviceId = x.serviceId;
            serviceType = x.serviceType;
          }
          return "";
        });

        // 方舟逻辑处理
        if (typeof urls.id === "string" && urls.id.indexOf("fang") !== -1) {
          serviceDomain = urls.dev;
          serviceId = 999;
        }
        if (
          serviceId === 0 &&
          // urls.use === "进入" &&
          urls.id !== 9991 &&
          urls.id !== 999 &&
          urls.id !== 888 &&
          urls.id !== 777
        ) {
          if (serviceQualifier === 1) {
            if (urls.name === "CATI 云电话调查") {
              setCatiTelVis(true);
              return;
            }
            if (!companyid || companyid === "0") {
              Modal.info({
                title: "访问提示",
                content:
                  "该服务仅限企业内部使用，请切换企业身份或新建企业后使用该服务"
              });
            } else if (!owner) {
              Modal.info({
                title: "访问提示",
                content: "企业暂未开通此服务，如需使用请联系企业管理员免费开通"
              });
            } else {
              openModal(serviceType, urls);
            }
          } else {
            openModal(serviceType, urls);
          }
          return;
        }
        // if (urls.id === 3) {
        //   Modal.confirm({
        //     title: "提示",
        //     content:
        //       "督导任务广场正在内部试用中，使用过程如果发现问题，请和我们及时反馈哦~",
        //     okText: "确定",
        //     cancelText: "取消",
        //     onOk() {
        //       if (!serviceDomain) {
        //         Modal.info({
        //           title: "提示",
        //           content: (
        //             <div>
        //               <p>即将上线，敬请期待</p>
        //             </div>
        //           )
        //           // onOk: () => {}
        //         });
        //       } else {
        //         final =
        //           serviceDomain +
        //           `?token=${token}${
        //             companyid ? `&companyid=${companyid}` : ""
        //           }&t=${t}&url=${serviceDomain}`;
        //         a.setAttribute("href", final);
        //         a.click();
        //         // window.open(final, "_blank");
        //         console.log("跳转链接：" + final);
        //       }
        //     }
        //   });
        //   return;
        // }
        if (urls.id === 999) {
          serviceDomain = "http://testcloud.treeyee.com/";
        }
        if (urls.id === 9991) {
          serviceDomain = "http://testcloud.treeyee.com/entrance";
        }
        if (urls.id === 888) {
          serviceDomain = "http://testreport.treeyee.com/";
        }
        if (urls.id === 777) {
          serviceDomain = "https://staging-wj.survey.work/entrance";
        }
        if (!serviceDomain) {
          // window.location.href = urls.pro;
          Modal.info({
            title: "提示",
            content: (
              <div>
                <p>即将上线，敬请期待</p>
              </div>
            )
            // onOk: () => {}
          });
        } else {
          let notice = "";
          if (serviceQualifier === 1 && (companyid * 1 === 0 || !companyid)) {
            notice =
              "该服务仅限企业内部使用，请切换企业身份或新建企业后使用该服务";
            Modal.info({
              title: "访问提示",
              content: notice
            });
            return;
          }
          if (serviceQualifier === 2 && companyid * 1 !== 0) {
            notice = "此功能需要个人用户，才可以使用~";
            Modal.info({
              title: "提示",
              content: notice
            });
            return;
          }
          //  定制如果不是这个企业的，进入之后服务还是以企业进入  退出一定得清除
          final =
            serviceDomain +
            `?token=${token}${
              companyid * 1 > 0 || cookies.get("jiluCompanyid") * 1 > 0
                ? `&companyid=${
                    companyid * 1 > 0 ? companyid : cookies.get("jiluCompanyid")
                  }`
                : ""
            }&t=${t}&role=manager&url=${serviceDomain}`;

          if (
            (urls.id === 4 || urls.id === 2) &&
            companyid === "0" &&
            !cookies.get("jiluCompanyid")
          ) {
            final += "&companyid=0";
          }
          if (urls.id === 3) {
            window.open(final, "_blank");
            return;
          }
          console.log("打开最终地址" + final);
          // window.open(final, "_blank");
          a.setAttribute("href", final);
          a.click();
        }
      });
    };
    const getDomFn = () => {
      const dom = activeInfo.name || activeInfo.companyName || "个人用户";
      // if (finnalCompanyid && finnalCompanyid !== 0) {
      //   dom = ;
      // } else {
      //   dom = "个人用户";
      // }
      return dom;
    };
    // 绑定后自动跳转
    const onHrefs = () => {
      // alert(forwardUrl);
      if (forwardUrl) {
        window.location.href = `${forwardUrl}?token=${cookies.get("shorcuts")}`;
      } else {
        setAlertBol(false);
      }
    };
    return (
      <div>
        <div
          style={{
            height: 48,
            background: "#F9E8C6",
            color: "#E69C00",
            fontSize: 12,
            textAlign: "center",
            position: "relative"
          }}
        >
          <div style={{ paddingTop: 5, fontWeight: 500 }}>
            调研工厂新版本已正式上线，欢迎{" "}
            <a
              href={`${loginAfterUrl()}?companyid=${companyid}${
                domainId ? `&domainId=${domainId}` : ""
              }`}
              style={{ fontWeight: 600 }}
            >
              使用体验
            </a>
          </div>
          <div style={{ fontWeight: 500 }}>
            旧版本将在近期下线，如有疑问，可联系客服咨询
          </div>
        </div>

        <div className="workbench">
          {/* 提醒弹窗 */}
          {/* {alertVisible && (
            <Modal
              title="提示"
              visible={alertVisible}
              onCancel={() => {
                setAlertVisible(false);
              }}
              footer={[
                <Button
                  type="primary"
                  onClick={() => {
                    setAlertVisible(false);
                  }}
                >
                  我知道了
                </Button>
              ]}
            >
              <div>
                您需要创建企业或者切换为企业身份后才可使用「明察暗访」服务
              </div>
            </Modal>
          )} */}
          {/* 新手指导 */}
          {stepsBol && (
            <Steps
              enabled={stepsBol}
              steps={steps}
              initialStep={0}
              onExit={() => {
                setStepsBol(false);
              }}
              options={{
                nextLabel: "下一步",
                prevLabel: "上一步",
                doneLabel: "完成"
              }}
            />
          )}
          {/* 绑定手机号 */}
          {bindingBol && bindingBolType === 2 && (
            <BindingAleft
              visible={bindingBol}
              onClose={() => {
                setBndingBol(false);
              }}
              getData={user.self}
              onSure={() => {
                setBndingBol(false);
                user.dispatch({ type: "init" });
              }}
              user={user}
              openAlertBol={() => {
                setAlertBol(true);
              }}
            />
          )}
          {/* 注册后第一次进入的弹窗 */}
          {regFirstBol && (
            <RegFrirstAlerts
              visible={regFirstBol}
              onClose={() => {
                setRegFirstBol(false);
                newUserPonit(owner);
              }}
              token={token}
              onHasName={() => {
                user.dispatch({ type: "init" });
                newUserPonit(owner);
              }}
            />
          )}

          {/* 绑定风险提示弹窗 */}
          {alertBol && (
            <Alerts
              visible={alertBol}
              onClose={() => {
                setAlertBol(false);
                if (user.self.weixinBinding) {
                  setBndingBol(true);
                }
              }}
              onSure={() => {
                const params = JSON.parse(
                  sessionStorage.getItem("bindingData")
                );
                axios
                  .post("/customer/bindingPhoneNumber?force=true", params)
                  .then(({ data }) => {
                    if (!data.success) {
                      setBndingBol(true);
                      return;
                    }
                    showMessage("success", "绑定成功！");
                    // 成功后跳转
                    onHrefs();
                    user.dispatch({ type: "init" });
                    // setAlertBol(false);
                  });
              }}
              user={user}
              alertBolType={1}
            />
          )}
          {/* 最左侧悬浮框,可打开新手指导 */}
          {xinYinBoxBol && (
            <div className="xinYinBox">
              <div className="box">
                <CloseCircleOutlined
                  onClick={() => {
                    setxinYinBoxBol(false);
                  }}
                />
                <a
                  onClick={() => {
                    newUserPonit(owner);
                  }}
                >
                  新手引导
                </a>
                <a href="https://www.yuque.com/surveywork/help" target="_blank">
                  使用说明
                </a>
              </div>
            </div>
          )}
          {/* CATI云电话调查弹窗 */}
          {catiTelVis && (
            <CatiModal
              visible={catiTelVis}
              onClose={() => {
                setCatiTelVis(false);
              }}
            />
          )}

          {!cookies.get("dingzhiBol") && !fangBol && (
            <div className="topBanner">
              <p />
            </div>
          )}
          <div className="innerBox spBox">
            {visible && (
              <AddCompany
                visible={visible}
                listData={{ id: "" }}
                onClose={() => {
                  setVisible(false);
                }}
                onGetList={() => {
                  getList();
                }}
                typeSp={1}
              />
            )}
            {/* 定制域名 个人用户显示的弹窗 */}
            {companyid === "0" &&
              !user.self.companySpecialAccount &&
              cookies.get("jiluCompanyid") && (
                <Alert
                  style={{ textAlign: "center", marginBottom: 24 }}
                  message={
                    <div>
                      <p style={{ marginBottom: 0, lineHeight: 2 }}>
                        如需加入{cookies.get("jiluCompanyName")}
                        ，请联系企业管理员添加
                      </p>
                    </div>
                  }
                  type="error"
                />
              )}
            {/* 当非定制个人用户显示弹窗 */}
            {companyid === "0" &&
              !user.self.companySpecialAccount &&
              rightHost.includes(window.location.hostname) &&
              !cookies.get("jiluCompanyid") && (
                <Alert
                  style={{ textAlign: "center", marginBottom: 24 }}
                  message={
                    <div>
                      <p style={{ marginBottom: 0, lineHeight: 2 }}>
                        如果您所在的公司（团队、组织）已在调研工厂创建调研企业，您只需联系企业管理员将您添加进企业，即可参与调研；
                      </p>
                      <p style={{ marginBottom: 0 }}>
                        如果您所在的公司（团队、组织）还未在调研工厂创建调研企业，您可自行免费创建哦~{" "}
                        <a
                          href="https://www.yuque.com/if3qb9/hy6sfb"
                          target="_blank"
                          style={{ color: "#1EC4F3" }}
                        >
                          了解调研企业功能
                        </a>
                      </p>
                    </div>
                  }
                  type="error"
                />
              )}
            {!activeInfo.owner &&
              companyid !== "0" &&
              !user.self.companySpecialAccount && (
                <Alert
                  message="您当前为企业员工身份，如需使用企业支付等功能，请联系企业管理员开通"
                  type="error"
                  style={{ textAlign: "center", marginBottom: 24 }}
                />
              )}
            {(user.self.companySpecialAccount ||
              cookies.get("dingzhiBol") ||
              !rightHost.includes(window.location.hostname)) && (
              <div style={{ textAlign: "center", position: "relative" }}>
                <a style={{ fontWeight: 500 }}>{getDomFn()}</a>
                {activeInfo.owner ? (
                  <Link
                    to={`/company/staff/list?companyid=${companyid}${
                      domainId ? `&domainId=${domainId}` : ""
                    }`}
                  >
                    <Button type="primary" ghost className="jrButton">
                      进入企业管理后台
                    </Button>
                  </Link>
                ) : (
                  ""
                )}
              </div>
            )}
            {!user.self.companySpecialAccount &&
              !cookies.get("dingzhiBol") &&
              rightHost.includes(window.location.hostname) && (
                <div style={{ textAlign: "center" }}>
                  {companyList.length === 0 ? (
                    <div className="rightWorkBox">
                      <a
                        style={{ fontWeight: 500, marginRight: 35 }}
                        className="oneShenfen"
                        onClick={() => {
                          Modal.confirm({
                            title: "企业免费版",
                            content: (
                              <div>
                                <p>企业免费版在个人版的基础上增加以下优势：</p>
                                <p>
                                  1.
                                  企业员工管理：可在企业中添加和管理本企业员工；添加员工后，可快捷添加员工进项目
                                </p>
                                <p>
                                  2.
                                  企业钱包：企业员工共用一个钱包，统一管理调研花费；
                                </p>
                                <p style={{ marginTop: 20 }}>
                                  点击【开通企业免费版】，按要求新建企业后，即可使用企业免费版
                                </p>
                              </div>
                            ),
                            okText: "开通企业免费版",
                            cancelText: "我知道了",
                            onOk() {
                              console.log(user);
                              if (user.self.phoneBinding) {
                                setVisible(true);
                              } else {
                                Modal.info({
                                  title: "提示",
                                  content:
                                    "请先绑定手机号，就可以免费开通企业啦",
                                  onOk() {
                                    setBndingBol(true);
                                  }
                                });
                              }
                            }
                          });
                        }}
                      >
                        了解企业免费版
                      </a>
                    </div>
                  ) : (
                    <div className="rightWorkBox">
                      <Dropdown overlay={menu}>
                        <a
                          className="ant-dropdown-link"
                          onClick={e => e.preventDefault()}
                        >
                          <span className="textFont">{getDomFn()}</span>
                          <DownOutlined style={{ marginLeft: 20 }} />
                        </a>
                      </Dropdown>
                      {activeInfo.owner ? (
                        <Link
                          to={`/company/staff/list?companyid=${companyid}${
                            domainId ? `&domainId=${domainId}` : ""
                          }`}
                        >
                          <Button type="primary" ghost className="jrButton">
                            进入企业管理后台
                          </Button>
                        </Link>
                      ) : (
                        ""
                      )}
                    </div>
                  )}
                </div>
              )}

            {loding && (
              <div className="lodingBox">
                <Spin spinning={loding} tip="正在加载工作台" />
              </div>
            )}

            {!loding && (
              <div>
                <div className="servicebox1">
                  <div className="itemname" style={{ marginTop: 0 }}>
                    我的服务
                  </div>
                  {workServer.length === 0 && <Empty />}
                  <Row>
                    {cookies.get("dingzhiBol")
                      ? workDingZhiServer.map((items, i) => {
                          if (items.shows) {
                            return (
                              <a
                                key={i}
                                className={items.btnClass}
                                onClick={() => dingzhiEnters(items)}
                              >
                                <div className="benchWorkItems benchWorkItems2">
                                  <div className="tops">
                                    <div className={items.class}>
                                      {items.tips}
                                    </div>
                                    <div className="lefts">
                                      <img src={items.icon} alt="" />
                                    </div>
                                    <div className="rights">
                                      <div className="title">{items.name}</div>
                                      <div className="description">
                                        {items.describe}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="bottoms">{items.use}</div>
                                </div>
                              </a>
                            );
                          }
                        })
                      : workServer.map((items, i) => {
                          return (
                            <a
                              key={`key${i}`}
                              className={items.btnClass}
                              onClick={() => enters(items)}
                            >
                              <div className="benchWorkItems benchWorkItems2">
                                <div className="tops">
                                  <div className={items.class}>
                                    {items.tips}
                                  </div>
                                  <div className="lefts">
                                    <img src={items.icon} alt="" />
                                  </div>
                                  <div className="rights">
                                    <div className="title">{items.name}</div>
                                    <div className="description">
                                      {items.describe}
                                    </div>
                                  </div>
                                </div>
                                <div className="bottoms">{items.use}</div>
                              </div>
                            </a>
                          );
                        })}
                  </Row>
                </div>
                {/* {!cookies.get("dingzhiBol") && !fangBol && (
                  <div className="servicebox2">
                    <div className="itemname" style={{ marginTop: 50 }}>
                      功能实验室
                    </div>
                    {functionLab.length === 0 && <Empty />}
                    <Row>
                      {functionLab.length > 0 &&
                        functionLab.map((items, i) => {
                          if (!items.show) {
                            return "";
                          }
                          return (
                            <div
                              key={i}
                              className="enter"
                              onClick={() => enters(items)}
                            >
                              <div className="benchWorkItems benchWorkItems2">
                                <div className="tops">
                                  <div className={items.class}>
                                    {items.tips}
                                  </div>
                                  <div className="lefts">
                                    <img src={items.icon} alt="" />
                                  </div>
                                  <div className="rights">
                                    <div className="title">{items.name}</div>
                                    <div className="description">
                                      {items.describe}
                                    </div>
                                  </div>
                                </div>
                                <div className="bottoms">{items.use}</div>
                              </div>
                            </div>
                          );
                        })}
                    </Row>
                  </div>
                )} */}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  })
);
